import { pumaAPI, dataAPI } from "./api"

export const getHomePage = (): Promise<string> =>
    pumaAPI.getText("resources/homepageurl")

export const getUserFormattingSettings =
    (): Promise<UserMenu.UserFormattingSettings> =>
        dataAPI
            .getJSON(
                "Users/Current()?$select=regionalFormat&%24expand=regionalFormat",
            )
            .then((response: Api.UserFormattingSettings) => {
                return {
                    shortDatePattern:
                        response.RegionalFormat?.DateTimeFormat
                            ?.ShortDatePattern,
                    shortTimeFormat:
                        response.RegionalFormat?.DateTimeFormat
                            ?.ShortTimePattern,
                    isInitialized: true,
                }
            })
